// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"793":"7102ebdd","872":"fb4b4ae8"}[chunkId] + ".chunk.js";
};